export const money = (value: number | string): string =>
  `$${Number(value).toFixed(2)}`.replace(/\d(?=(\d{3})+\.)/g, '$&,')
